import React from "react";
import AwardBadge from "../Badge";

const Left = () => {
    return (
        <div className="py-2 flex-1 flex flex-col items-start justify-center gap-3">
            <p className="text-[2rem] lg:text-[4rem] font-bold tracking-wide text-headingColor">
                О ресторане
            </p>
            <p className="text-base text-textColor text-center md:text-left md:w-[80%]">
                Рестобар Mon Tresor приглашает вас в гастрономическое путешествие, где главную роль играют качественные продукты, внимание к деталям и любовь к своему делу.
                За вкус и качество блюд отвечает команда во главе с бренд-шефом Александром Кравченко и шеф-поваром Максимом Васильевым.
            </p>
            <p className="text-base text-textColor text-center md:text-left md:w-[80%]">
                В Mon Tresor комфортно в любое время года. В теплый сезон гости могут расположиться на уютной летней террасе на первом этаже, наслаждаясь атмосферой города и любимыми блюдами.
                Для удобства гостей предусмотрена парковка, а для самых маленьких посетителей - детское меню и игры, которые помогут сделать семейный отдых еще приятнее.
                Мы любим удивлять новыми вкусами, поэтому каждый сезон обновляем меню, вдохновляясь лучшими продуктами и актуальными гастрономическими идеями.
            </p>
            <p className="text-base text-textColor text-center md:text-left md:w-[80%]">
                Здесь можно провести романтический вечер, встретиться с друзьями, отметить важное событие или просто сделать паузу среди городского ритма.
                Откройте меню, выберите любимое блюдо и отправляйтесь в свое гастрономическое путешествие вместе с Mon Tresor.
                Добро пожаловать!
            </p>
            <AwardBadge
                year={2026}
                restaurantName="Mon Tresor"
                awardTitle="Лучший интерьер"
                link="https://ru.restaurantguru.com/Mon-Tresor-Yoshkar-Ola"
            />
        </div>
    );
};

export default Left;
